<template>
	<div v-if="show" class="mainbartop d-flex d-justify-content-center align-items-center  text-center w-100">
		<div class="mainbartoptext1">{{ $t('promobar.limitedtimeSale', 'Limited-Time Sale') }}: <span class="mainbartoptext2">{{ subscription?.scdiscount }}% Off</span> <b>{{ subscription?.stdescription }}</b>, {{ $t('promobar.yoursnow', 'Grab Yours Now!') }}</div>
		<div class="mainbartoptext1">
			<vue-countdown :time="duration" v-slot="{ days, hours, minutes, seconds }">
				- {{ $t('promobar.timeremaining', 'Time Remaining') }}：{{ days }} {{ $t('common.days', 'days') }} , {{ hours }} {{ $t('common.hours', 'hours') }} , {{ minutes }} {{ $t('common.minutes', 'minutes') }}, {{ seconds }} {{ $t('common.seconds', 'seconds') }}
			</vue-countdown>
		</div>
	</div>
</template>
<script lang="ts" setup>
import { onBeforeMount, ref } from 'vue';
import axios from 'axios';
import moment from 'moment';
import VueCountdown from '@chenfengyuan/vue-countdown';
import { userMainStore } from '@/store/userMainStore';

const main = userMainStore();
let token = localStorage.getItem("token");
const subscription = ref();
const duration = ref();
const show = ref(false);

onBeforeMount(
	async () => {
		if (main.isavailable) await getSubscription();
		getTimeLeft();
	});


function getTimeLeft() {
	if (!subscription.value) return;
	let enddate = moment(subscription.value.sduntildate);
	let todaysdate = moment(subscription.value.now);
	let timeleft = enddate.diff(todaysdate, 'milliseconds');
	duration.value = moment.duration(timeleft, 'milliseconds');
}

function getSubscription() {
	return new Promise(async (resolve) => {
		await axios
			.get('/api/v1/getsubscription/' + 6, {
				headers: { Authorization: `${token}` },
				withCredentials: true
			})
			.then(response => {
				subscription.value = response.data.Data;
				if (subscription.value.sdpromo) {
					show.value = true;
				}
				resolve(true);
			});
	})
}
</script>
<style scoped lang="scss">
.mainbartop {
	background: var(--Off-black-100, #161616);
	display: flex;
	padding: 24px 0px;
	justify-content: center;
	align-items: center;
	gap: 10px;
	align-self: stretch;
	transition: all 0.3s linear;
}

.mainbartoptext1 {
	color: var(--Off-white, #F5F5F5);
	font-family: Roboto;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	letter-spacing: 0.1px;
}

.mainbartoptext2 {
	color: var(--Green-100, #75AE3D);
	font-family: Roboto;
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	letter-spacing: 0.1px;
}

@media (max-width: 768px) {
	.mainbar {
		font-size: 12px;
	}
}
</style>